import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

const ListProjectPlansAllowed = () => useFeatureAvailable(Feature.PROJECT_PLAN);

export default ListProjectPlansAllowed;
